import React, { useMemo } from 'react';
import { FormGroup } from '@mui/material';
import { ReferralDataAttributes, ReferralTypeEnum } from '@loyalty/editor-components';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectField } from '../../../../shared/forms/fields/SelectField';
import { SwitchField } from '../../../../shared/forms/fields/SwitchField';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';
import { useEditorStore } from '../../../store';

type FormValue = TraitFormValue<ReferralDataAttributes, void>;

export function ReferralWidgetTraits() {
  const { t, i18n } = useTranslation();

  const { control } = useFormContext<FormValue>();

  // Use Zustand store
  const editorService = useEditorStore(state => state.editorService);
  const editor = editorService?.editor;

  const options = useMemo(
    () => [
      {
        id: ReferralTypeEnum.CODE,
        name: t('editor.referral.traits.type.code'),
      },
      {
        id: ReferralTypeEnum.P_LINK,
        name: t('editor.referral.traits.type.p_link'),
      },
      ...(getLocalizedProperty(editor?.Config.context.referralConfig, 'link', i18n.language)?.length
        ? [
            {
              id: ReferralTypeEnum.E_LINK,
              name: t('editor.referral.traits.type.e_link'),
            },
          ]
        : []),
    ],
    [editor?.Config.context.referralConfig, t],
  );

  return (
    <FormGroup>
      <Trait>
        <SelectField
          control={control}
          name="attributes.referralType"
          label={t('editor.referral.traits.codeOrLink')}
          options={options}
        />
        <Trait>
          <SwitchField<FormValue>
            name="attributes.showOnlyButton"
            label={t('editor.referral.traits.showOnlyButton')}
          />
        </Trait>
      </Trait>
    </FormGroup>
  );
}
